export default function shouldShowTutorial({
  shouldNeverShowTutorial,
  firstLogin,
  lastLogin,
}) {
  if (shouldNeverShowTutorial) {
    return false;
  }

  if (!firstLogin || !lastLogin) {
    return false;
  }

  const firstLoginDate = new Date(firstLogin);
  const lastLoginDate = new Date(lastLogin);

  const difference = lastLoginDate - firstLoginDate;
  const diffHours = difference / (1000 * 3600);
  if (diffHours < 2) {
    return true;
  } else {
    return false;
  }
}
